import usePreviousSearchText from './usePreviousSearchText';

export default usePreviousSearchText;
